import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EAssignApprovalUnitsFormNames = {
	assetType: 'assetType',
	assetSubType: 'assetSubType',
	unit: 'unit',
} as const;

export type TAssignApprovalUnitsFormNames = TValueOfStringRecord<typeof EAssignApprovalUnitsFormNames>
